// packages/web/src/components/FullscreenLoader.tsx — misma API. Sin animación "ping" que distrae;
// respeta prefers-reduced-motion.
import type { ReactNode } from 'react';
import { Loader2 } from 'lucide-react';

interface FullscreenLoaderProps { title: string; subtitle?: string; icon?: ReactNode }

export function FullscreenLoader({ title, subtitle, icon }: FullscreenLoaderProps) {
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center p-6" role="dialog" aria-modal="true" aria-live="polite" aria-label={title}>
      <div className="bg-white rounded-2xl shadow-2xl px-8 py-9 max-w-sm w-full text-center">
        <span className="inline-flex rounded-full bg-marzano-50 p-4 mb-4">
          {icon ?? <Loader2 aria-hidden className="w-8 h-8 text-marzano-600 animate-spin motion-reduce:animate-none" />}
        </span>
        <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
        {subtitle && <p className="text-sm text-slate-600 leading-relaxed mt-1.5">{subtitle}</p>}
      </div>
    </div>
  );
}
